import React from 'react'
import { Button, Card, CardActions, CardContent, Fade, MenuItem, TextField, Typography, withStyles } from '@material-ui/core'
import { useContext } from 'react'
import { GameContext } from '../GameProvider'

const GroupMenu = (props) => {
  const gameContext = useContext(GameContext)

  if (gameContext.groups === undefined || gameContext.selectedGroup === undefined) {
    return (<div></div>)
  }

  return (
    <TextField
      select
      value={gameContext.selectedGroup}
      onChange={(event) => {
        gameContext.leaveGroup(gameContext.selectedGroup)
        gameContext.changedGroup(event.target.value)
        gameContext.joinGroup(event.target.value)
      }}
      label={'Group'}
    >
      {gameContext.groups.map(group =>
        <MenuItem key={group.name} value={group.name}>
          <Typography>{group.label}</Typography>
        </MenuItem>
      )}
    </TextField>
  )
}

const stylesGroupSelectCard = (theme) => ({
  root: {
    marginBottom: theme.spacing.unit * 2,
  },
  cardActions: {
    justifyContent: 'flex-end'
  }
})

function GroupSelectCard(props) {
  const { classes } = props

  const gameContext = useContext(GameContext)

  return (
    <Fade in={gameContext.groups.length > 0}>
      <Card className={classes.root}>
        <CardContent>
          <GroupMenu/>
        </CardContent>
        <CardActions className={classes.cardActions}>
          <Button
            onClick={() => gameContext.setOpenNewGameSettingsDialog(true)}
            color='primary'
          >
            部屋を作成
          </Button>
        </CardActions>
      </Card>
    </Fade>
  )
}

export default withStyles(stylesGroupSelectCard, { withTheme: true })(GroupSelectCard)


// WEBPACK FOOTER //
// ./src/Pages/Game/components/GroupSelectCard.js